import * as React from "react";
import {useEffect} from "react";
import {Box} from "@mui/material"
import {getSubmit} from "@ui-seeker/utils";

import {useUserApp} from "@hooks";


export default function IframePage({ url }) {
    const { username } = useUserApp()

    useEffect(() => {
        getSubmit(
            '/api/ia-options/save-activity'
        ).catch(r => console.error(r))
    }, []);

    return <Box style={{ width: '100%', height: '100%', pr: 0 }}>
        <iframe
            src={`${url}?username=${username}`}
            allowFullScreen
            style={{
                width: '100%',
                height: '84vh',
                border: 'none',
            }}
        />
    </Box>
}